<section id="left_menu" *ngIf="isLeftmenu" class="h-100">
  <div class=" px-2 m-0 h-100">
    <div class="mt-0 sidebar px-2 h-100">
      <div class="d-flex flex-column align-items-center align-items-sm-start px-0 pt-2 text-white min-vh-100 ">
        <!-- <a href="/" class="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-white text-decoration-none">
                <span class="fs-5 d-none d-sm-inline">Menu</span>
            </a> -->
        <ul class="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start w-100" id="menu">
          <div class="nav-item-wrapper pt-4">
            <li class="nav-item" routerLink="/home" routerLinkActive="active">
              <a class="nav-link align-middle px-2 w-100 ">
                <svg width="28" height="25" class="bi bi-person-add sidenavbar_list" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13 12C13 11.4477 13.4477 11 14 11H19C19.5523 11 20 11.4477 20 12V19C20 19.5523 19.5523 20 19 20H14C13.4477 20 13 19.5523 13 19V12Z"
                    stroke="white" fill="#004F93" stroke-width="1.0" stroke-height="2.5" />
                  <path
                    d="M4 5C4 4.44772 4.44772 4 5 4H9C9.55228 4 10 4.44772 10 5V12C10 12.5523 9.55228 13 9 13H5C4.44772 13 4 12.5523 4 12V5Z"
                    stroke="white" fill="#004F93" stroke-width="1.0" stroke-height="2.5" />
                  <path
                    d="M4 17C4 16.4477 4.44772 16 5 16H9C9.55228 16 10 16.4477 10 17V19C10 19.5523 9.55228 20 9 20H5C4.44772 20 4 19.5523 4 19V17Z"
                    stroke="white" fill="#004F93" stroke-width="1.0" stroke-height="2.5" />
                  <path
                    d="M13 5C13 4.44772 13.4477 4 14 4H19C19.5523 4 20 4.44772 20 5V7C20 7.55228 19.5523 8 19 8H14C13.4477 8 13 7.55228 13 7V5Z"
                    stroke="white" fill="#004F93" stroke-width="1.0" stroke-height="2.5" />
                </svg>
                <span class="ms-2 pt-1 d-none d-sm-inline sidenavbar_list fw-semibold"
                  (click)="GotoMydashboard()">{{'Dashboard'|translate}}</span>
              </a>
            </li>
          </div>
          <div class="nav-item-wrapper">
            <li class="nav-item" *ngIf="roleId <=2" routerLink="/admins" routerLinkActive="active">
              <a class="nav-link align-middle px-2 sidebar_background w-100">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor"
                  class="bi bi-person-add sidenavbar_list" viewBox="0 0 21 21">
                  <path
                    d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                  <path
                    d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                </svg>
                <span class="ms-2 d-none d-sm-inline sidenavbar_list fw-semibold"
                  (click)="GotomySystemAdmins()">{{'SystemAdmins'|translate}}</span>
              </a>
            </li>
          </div>
          <div class="nav-item-wrapper">
            <li class="nav-item" *ngIf="roleId <=3" routerLink="/company-offices" routerLinkActive="active">
              <a class="nav-link align-middle px-2 sidebar_background">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" fill="currentColor"
                  class="bi bi-buildings-fill sidenavbar_list" viewBox="0 0 24 24">
                  <path
                    d="M17,11V3H7v4H3v14h8v-4h2v4h8V11H17z M7,19H5v-2h2V19z M7,15H5v-2h2V15z M7,11H5V9h2V11z M11,15H9v-2h2V15z M11,11H9V9h2 V11z M11,7H9V5h2V7z M15,15h-2v-2h2V15z M15,11h-2V9h2V11z M15,7h-2V5h2V7z M19,19h-2v-2h2V19z M19,15h-2v-2h2V15z">
                  </path>
                </svg>
                <span class="ms-2 d-none d-sm-inline sidenavbar_list fw-semibold" (click)="GotoCompanyOffices()">
                  {{'Company/Office'|translate}}</span>
              </a>
            </li>
          </div>

          <div class="nav-item-wrapper">
            <li class="nav-item" *ngIf="roleId <=3 " routerLink="/broker" routerLinkActive="active">
              <a class="nav-link align-middle px-2 sidebar_background">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" fill="currentColor"
                  class="bi bi-person-add sidenavbar_list" viewBox="0 0 21 21">
                  <path
                    d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                  <path
                    d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                </svg>
                <span class="ms-2 d-none d-sm-inline sidenavbar_list fw-semibold"
                  (click)="GotoBroker()">{{'Brokers'|translate}}</span>
              </a>
            </li>
          </div>
          <div class="nav-item-wrapper">
            <li class="nav-item" *ngIf="roleId <=4" routerLink="/office-manager" routerLinkActive="active">
              <a class="nav-link align-middle px-2 sidebar_background">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" fill="currentColor"
                  class="bi bi-person-add sidenavbar_list" viewBox="0 0 21 21">
                  <path
                    d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                  <path
                    d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                </svg>
                <span class="ms-2 d-none d-sm-inline sidenavbar_list fw-semibold"
                  (click)="GotoOfficeManager()">{{'OfficeManagers'|translate}}</span>
              </a>
            </li>
          </div>
          <div class="nav-item-wrapper">
            <li class="nav-item" *ngIf="roleId <=5 " routerLink="/agent" routerLinkActive="active">
              <a class="nav-link align-middle px-2 sidebar_background">
                <svg xmlns="http://www.w3.org/2000/svg" height="28" fill="currentColor"
                  class="bi bi-person-add sidenavbar_list" viewBox="0 0 21 21">
                  <path
                    d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                  <path
                    d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                </svg>
                <span class="ms-2 d-none d-sm-inline sidenavbar_list fw-semibold"
                  (click)="GotoAgent()">{{'Agents'|translate}}</span>
              </a>
            </li>
          </div>
          <!-- <div class="nav-item-wrapper">
            <li class="nav-item pt-1" *ngIf="roleId == 4 || roleId == 6" routerLink="/contact" routerLinkActive="active">
              <a class="nav-link align-middle d-flex px-3 sidebar_background">
                <svg xmlns="http://www.w3.org/2000/svg"  height="25" fill="currentColor"
                  class="bi bi-person-add sidenavbar_list" viewBox="0 0 16 16">
                  <path
                    d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                  <path
                    d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                </svg>
                <span class="ms-2 pt-1 d-none d-sm-inline sidenavbar_list fw-bold" (click)="GotoContacts()">Contact</span>
              </a>
            </li>
          </div> -->
        </ul>
        <hr>
      </div>
    </div>
  </div>
</section>
